import React from "react";
import styled, { css } from "styled-components";

const ShimmeringWrapper = styled.div`
  // background-color: red;
  width:100%;
  display:flex;
  justify-content:${(props) => props?.justifyContent ? props?.justifyContent  : 'center' || 'center'};
  .shine {
    background: #e1e1e1;
    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-repeat: no-repeat;
    background-size: infinite; 
    display: ${(props) => props.visible ? `inline-block` : `none`};
    position: relative; 
    height: ${(props) => props.height};
    width: ${(props) => props.width};
    margin-top: ${(props) => props.marginTop};
    margin-bottom: ${(props) => props.marginBottom};
    border-radius: ${(props) => props.borderRadius};
    animation-duration: 1s;
    animation-fill-mode: forwards; 
    animation-iteration-count: infinite;
    animation-name: placeholderShimmer;
    animation-timing-function: linear;
  }


  
  @keyframes placeholderShimmer {
    0% {
      background-position: -700px 0;
    }
  
    100% {
      background-position: 700px 0; 
    }
  }
`;

const ShimmerPlaceholder = ({
  marginTop = "0em",
  height = "2.75em",
  marginBottom = "0.3em",
  width = "100%",
  justifyContent = "center",
  borderRadius = "0.75em",
  visible = true
}) => {
  return (
    <>
      <ShimmeringWrapper 
        height={height}
        width={width}
        justifyContent={justifyContent}
        marginTop={marginTop}
        marginBottom= {marginBottom}
        borderRadius={borderRadius}
        visible={visible}
      >
        <div className={"shine"}></div>
      </ShimmeringWrapper>
    </>
  );
};

export default ShimmerPlaceholder;
